import { render, staticRenderFns } from "./Spacer.vue?vue&type=template&id=7a16bb88&scoped=true&"
import script from "./Spacer.vue?vue&type=script&lang=js&"
export * from "./Spacer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a16bb88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a16bb88')) {
      api.createRecord('7a16bb88', component.options)
    } else {
      api.reload('7a16bb88', component.options)
    }
    module.hot.accept("./Spacer.vue?vue&type=template&id=7a16bb88&scoped=true&", function () {
      api.rerender('7a16bb88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/templates/invoices/schema/Spacer.vue"
export default component.exports